<template>
  <div>
    <v-row class="fig_wrapper mt-10">
      <v-col cols="12" v-if="drawingList.length === 0">
        <div class="none__data__content" style="border: 0px;padding-top: 50px;">
          <div class="thumb__bg"></div>
          <p>{{$t('component.drawing.no_data')}}</p>
        </div>
      </v-col>
      <template v-for="(drawing, index) in drawingList">
        <v-col cols="12" md="4" @click="fnOpenView(drawing, index+1)" :key="index">
          <div class="fig__inner__content" :class="{'actv' : drawing.ind_representative == 'Y'}">
            <h2 v-if="drawing.ind_representative == 'Y'" class="nec_title fig__title__content__new">
              <div>{{ $t('myapplication.myapplication_details.fields.fig') + (index + 1)}}</div>
              <div class="actv__title">{{$t('application.patent.fields.representative_drawing')}}</div>
            </h2>
            <h2 v-if="drawing.ind_representative == 'N'" class="nec_title fig__title__content__new">
              <div>{{ $t('myapplication.myapplication_details.fields.fig') + (index + 1)}}</div>
              <div class="actv__title"></div>
            </h2>
            <div class="fig_wrap d-flex mt-10">
              <div>
                <v-img :src="drawing.img_en"></v-img>
                <div class="en__op op__text">{{$t('common.common.en')}}</div>
              </div>
              <div>
                <v-img :src="drawing.img_ar"></v-img>
                <div class="ar__op op__text">{{$t('common.common.ar')}}</div>
              </div>
            </div>
          </div>
        </v-col>
      </template>
    </v-row>

    <v-dialog v-model="dialog" flat persistent max-width="900" content-class="br_none">
      <v-card class="br_none modal_comfirm_wrap type3 drawing__dialog__card">
        <v-btn class="modal_close ty2" @click="fnCloseView()" elevation="10" fab dark color="indigo">
          <v-icon dark>mdi-close</v-icon>
        </v-btn>
        <h2 class="header_title02 type2 type3">{{ $t('myapplication.myapplication_details.fields.fig') + viewImg.no }}</h2>
        <v-row class="fd_column mt-10">
          <v-col cols="12" class="d-flex pb-0">
            <v-chip dark small color="primary">{{ $t('myapplication.myapplication_details.fields.english') }}</v-chip>
            <v-spacer></v-spacer>
            <v-chip dark small color="primary">{{ $t('myapplication.myapplication_details.fields.arabic') }}</v-chip>
          </v-col>
          <v-col cols="12" class="d-flex">
            <v-img width="40%" :class="{'no_fig' : !viewImg.en_exist}" :src="viewImg.en"></v-img>
            <v-spacer class="hidden_lr20"></v-spacer>
            <v-img width="40%" :class="{'no_fig' : !viewImg.ar_exist}" :src="viewImg.ar"></v-img>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import noImg from '@/assets/img/no_fig.jpg'

export default {
  props: {
    seq:  String
  },
  components:{
  },
  data () {
		return {
      dialog : false,
      drawingList : [],
      downLoadUrl : process.env.VUE_APP_BASE_URL + '/file/download/',
      viewImg : {
        no : '',
        ar : '',
        en : ''
      }
    }
  },
  mounted(){
    this.fnGetDrawings()
  },
  methods : {
    fnGetDrawings(){
      requestApi({
        url: '/applications/' + this.seq + '/drawings',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].img_ar = utils.isNull(res.data.list[i].drawing_image_ar_key) ? noImg : this.downLoadUrl + res.data.list[i].drawing_image_ar_key +'/resize/400'
              res.data.list[i].img_en = utils.isNull(res.data.list[i].drawing_image_en_key) ? noImg : this.downLoadUrl + res.data.list[i].drawing_image_en_key +'/resize/400'
            }
            this.drawingList = res.data.list
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetDrawings()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnOpenView(drawing, no){
      this.viewImg.no = no
      this.viewImg.ar_exist = !utils.isNull(drawing.drawing_image_ar_key)
      this.viewImg.en_exist = !utils.isNull(drawing.drawing_image_en_key)
      this.viewImg.ar = utils.isNull(drawing.drawing_image_ar_key) ? noImg : this.downLoadUrl + drawing.drawing_image_ar_key
      this.viewImg.en = utils.isNull(drawing.drawing_image_en_key) ? noImg : this.downLoadUrl + drawing.drawing_image_en_key
      this.dialog = true
    },
    fnCloseView(){
      this.dialog = false
      this.viewImg.no = ''
      this.viewImg.ar = ''
      this.viewImg.en = ''
    }
  }
}
</script>
<style>
.nec_title.fig_title.active {
  visibility : visible
}
.v-image__image.v-image__image--cover {
  background-size: 100%;
}
</style>